import * as React from "react";
import { CustomerNotifications } from "src/components/shared/CustomerNotifications";
import { NotificationLocation } from "__generated__/api";
import { CustomerNotificationsWrapperFlexModuleResult, CustomerNotificationsWrapperProps } from "./typings";
import { CustomerNotificationsInPage } from "src/components/shared/StorefrontWizard/TravelAdvisory/CustomerNotificationsInPage";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { Experiment as Experiments } from "src/components/utility/experiment";
import { Viewport, ViewSmall, ViewMedium } from "@shared-ui/viewport-context";
import { UitkSpacing } from "uitk-react-spacing";
import { CovidBannerVersions } from "components/shared/ReasonsToBelieve/ReasonsToBelieveWrapper";
import { withStores } from "stores";
import { observer } from "mobx-react";
import { useProvidedState } from "@shared-ui/provided-state-context";
import { CustomerNotificationStateEvent } from "@shared-ui/customer-notifications";
import { UitkHeading } from "uitk-react-text";

export const CustomerNotificationsWrapper = withStores("flexModuleModelStore")(
  observer((props: CustomerNotificationsWrapperProps) => {
    const { flexModuleModelStore, flexTemplateNode } = props;
    const { id } = flexTemplateNode;
    const model = flexModuleModelStore.getModel(id) as CustomerNotificationsWrapperFlexModuleResult | null;
    const [state] = useProvidedState();

    if (!model) {
      return null;
    }

    const { location, className, reasonsToBelieve, reasonsToBelieveVersion, title } = model;

    const notificationLocations = {
      [NotificationLocation.AFTER_HEADER]: NotificationLocation.AFTER_HEADER,
      [NotificationLocation.FOOTER]: NotificationLocation.FOOTER,
      [NotificationLocation.IN_PAGE]: NotificationLocation.IN_PAGE,
      [NotificationLocation.IN_PAGE_AD]: NotificationLocation.IN_PAGE_AD,
      [NotificationLocation.POPUP]: NotificationLocation.POPUP,
      [NotificationLocation.PRE_HEADER]: NotificationLocation.PRE_HEADER,
      [NotificationLocation.AFTER_WIZARD]: NotificationLocation.AFTER_WIZARD,
    };

    const notificationLocation = notificationLocations[location];
    if (!notificationLocation) {
      return null;
    }

    const shouldDisplayTitle =
      title &&
      state?.customerNotificationControlState?.[location]?.state ===
        CustomerNotificationStateEvent.CustomerNotificationInitialized;

    const wrapperTitle = shouldDisplayTitle && (
      <UitkSpacing padding={{ blockend: "three" }}>
        <UitkHeading tag="h2" size={3} data-testid="customer-notifications-wrapper-title">
          {title}
        </UitkHeading>
      </UitkSpacing>
    );

    const customerNotificationsInPage = (
      <UitkSpacing padding={{ blockend: reasonsToBelieveVersion !== CovidBannerVersions.THREE ? "twelve" : "unset" }}>
        <div className="ReasonsToBelieveWrapper" data-testid="reasons-to-believe-wrapper">
          {wrapperTitle}
          <CustomerNotificationsInPage reasonsToBelieveVersion={reasonsToBelieveVersion} />
        </div>
      </UitkSpacing>
    );

    return reasonsToBelieve && location === notificationLocations.IN_PAGE ? (
      <Viewport>
        <ViewSmall>
          <Experiment name={Experiments.Home_Simplified_Search_Entry}>
            <ExperimentControl>{customerNotificationsInPage}</ExperimentControl>
            <ExperimentVariant bucket={1}>{customerNotificationsInPage}</ExperimentVariant>
            <ExperimentVariant bucket={2} />
          </Experiment>
        </ViewSmall>
        <ViewMedium>{customerNotificationsInPage}</ViewMedium>
      </Viewport>
    ) : (
      <div className="CustomerNotificationsWrapper" data-testid="customer-notifications-wrapper">
        {wrapperTitle}
        <CustomerNotifications location={location} className={className} />
      </div>
    );
  })
);

export default CustomerNotificationsWrapper;
